"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayMinMaxItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const ItemInput = (0, react_1.forwardRef)(({ width, ...props }, ref) => ((0, jsx_runtime_1.jsx)(material_1.Input, { ...props, ref: ref, sx: ({ palette, transitions }) => ({
        width,
        fontSize: 11,
        height: 16,
        color: palette.white,
        transition: transitions.create("color"),
        maxWidth: "8ch",
        "::before": {
            display: "none",
        },
        "::after": {
            borderBottomStyle: "dotted",
            borderBottomColor: palette.white,
            borderBottomWidth: 1,
        },
        ":hover": {
            "::after": {
                transform: "scaleX(1) translateX(0)",
            },
        },
        [`.${material_1.inputClasses.disabled}`]: {
            WebkitTextFillColor: "initial",
        },
    }) })));
const ArrayMinMaxItems = ({ arrayId, }) => {
    const { control, setValue } = (0, react_hook_form_1.useFormContext)();
    const [minItems, maxItems] = (0, react_hook_form_1.useWatch)({
        control,
        name: [
            `flattenedCustomExpectedValueList.${arrayId}.data.minItems`,
            `flattenedCustomExpectedValueList.${arrayId}.data.maxItems`,
        ],
    });
    const infinityController = (0, react_hook_form_1.useController)({
        control,
        name: `flattenedCustomExpectedValueList.${arrayId}.data.infinity`,
    });
    const [minItemsWidth, setMinItemsWidth] = (0, react_1.useState)(0);
    const [maxItemsWidth, setMaxItemsWidth] = (0, react_1.useState)(0);
    const [maxItemsHovered, setMaxItemsHovered] = (0, react_1.useState)(false);
    const minItemsInputRef = (0, react_1.useRef)();
    const maxItemsInputRef = (0, react_1.useRef)();
    const setInputSize = (0, react_1.useCallback)(() => {
        setMinItemsWidth(minItemsInputRef.current?.value.length ?? 1);
        setMaxItemsWidth(maxItemsInputRef.current?.value.length ?? 1);
    }, []);
    (0, react_1.useEffect)(() => {
        setInputSize();
    }, [setInputSize]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, { display: "flex", gap: 1.25, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                    display: "flex",
                    borderRadius: 7.5,
                    overflow: "hidden",
                }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            py: 0.25,
                            px: 1,
                            background: ({ palette }) => palette.gray[80],
                        }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallCaps", sx: {
                                fontSize: 11,
                                color: ({ palette }) => palette.gray[30],
                            }, children: "Min" }) }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            py: 0.25,
                            pr: 1,
                            pl: 0.75,
                            background: ({ palette }) => palette.gray[90],
                        }, children: (0, jsx_runtime_1.jsx)(ItemInput, { value: minItems, inputRef: minItemsInputRef, width: `${minItemsWidth || 1}ch`, onChange: (evt) => {
                                const target = evt.target;
                                const valueAsNumber = Number(target.value);
                                if (!Number.isNaN(valueAsNumber)) {
                                    const min = Math.max(0, valueAsNumber);
                                    if (min > maxItems) {
                                        setValue(`flattenedCustomExpectedValueList.${arrayId}.data.maxItems`, min, { shouldDirty: true });
                                    }
                                    setValue(`flattenedCustomExpectedValueList.${arrayId}.data.minItems`, min);
                                    setImmediate(() => {
                                        setInputSize();
                                    });
                                }
                            } }) })] }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                    display: "flex",
                    borderRadius: 7.5,
                    overflow: "hidden",
                }, onMouseEnter: () => setMaxItemsHovered(true), onMouseLeave: () => setMaxItemsHovered(false), children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            py: 0.25,
                            px: 1,
                            background: ({ palette }) => palette.gray[80],
                        }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallCaps", sx: {
                                fontSize: 11,
                                color: ({ palette }) => palette.gray[30],
                            }, children: "Max" }) }), (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            py: 0.25,
                            pr: 1,
                            pl: 0.75,
                            background: ({ palette }) => palette.gray[90],
                            fontSize: 11,
                        }, children: [(0, jsx_runtime_1.jsxs)(material_1.Collapse, { orientation: "horizontal", in: maxItemsHovered, sx: {
                                    [`.${material_1.collapseClasses.wrapperInner}`]: {
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                }, collapsedSize: infinityController.field.value ? 0 : `${maxItemsWidth || 1}ch`, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, jsx_runtime_1.jsx)(ItemInput, { value: maxItems, inputRef: maxItemsInputRef, disabled: infinityController.field.value, width: `${maxItemsWidth || 1}ch`, onChange: (evt) => {
                                                const target = evt.target;
                                                const valueAsNumber = Number(target.value);
                                                if (!Number.isNaN(valueAsNumber)) {
                                                    const max = Math.max(0, valueAsNumber);
                                                    if (max < minItems) {
                                                        setValue(`flattenedCustomExpectedValueList.${arrayId}.data.minItems`, max, { shouldDirty: true });
                                                    }
                                                    setValue(`flattenedCustomExpectedValueList.${arrayId}.data.maxItems`, max);
                                                    setImmediate(() => {
                                                        setInputSize();
                                                    });
                                                }
                                            } }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "smallTextLabels", sx: {
                                            pl: 0.5,
                                            fontSize: 11,
                                            color: ({ palette }) => palette.white,
                                            whiteSpace: "nowrap",
                                            pr: 0.5,
                                        }, children: "or allow" })] }), (0, jsx_runtime_1.jsx)(material_1.Collapse, { orientation: "horizontal", in: maxItemsHovered, sx: {
                                    [`.${material_1.collapseClasses.wrapperInner}`]: {
                                        display: "flex",
                                        alignItems: "center",
                                    },
                                }, collapsedSize: infinityController.field.value ? 12 : 0, children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "smallTextLabels", sx: {
                                        fontSize: 11,
                                        color: ({ palette }) => palette.white,
                                        whiteSpace: "nowrap",
                                    }, children: ["\u221E", (0, jsx_runtime_1.jsx)(material_1.Checkbox, { ...infinityController.field, checked: infinityController.field.value, sx: {
                                                ml: 0.5,
                                                width: 12,
                                                height: 12,
                                                "&, > svg": { fontSize: 12 },
                                            }, size: "small" })] }) })] })] })] }));
};
exports.ArrayMinMaxItems = ArrayMinMaxItems;
